<template>
  <client-only>
    <Modal
      v-bind="modalProps"
      :width="$device.isMobile ? '350' : '577'"
      @closed="onModalClose"
    >
      <div class="flex justify-center relative py-7 px-9">
        <div class="inline relative">
          <slot />
          <div class="close" @click="toggleActivation(false)">
            <OSvg svg="thin-cross" />
          </div>
        </div>
      </div>
    </Modal>
  </client-only>
</template>

<script>
import modalMixin from '@/mixins/modal'

export default {
  name: 'ThumbnailPreview',
  mixins: [modalMixin({ modalName: 'thumbnail-preview-modal' })]
}
</script>

<style lang="postcss" scoped>
>>> .thumbnail-preview-modal {
  @apply bg-transparent shadow-none;
}

>>> .oimage img {
  max-width: 100% !important;
}

.close {
  @apply absolute z-10 cursor-pointer rounded-full p-5 bg-orange-300;
  top: -2.5rem;
  right: -2.5rem;
}
</style>
